import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";
import QRCode from "qrcode.react";
import "../Verification.scss";
import axios from "axios";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import UserContextAPI, { UserContext } from "../../../Context/UserContextAPI";

const VerificationById = ({ children }) => {
  const { settingsData } = useContext(UserContext);
  const websiteUrlWithBase64ID = settingsData?.qrcode_url;
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const { pathname } = useLocation();
  const [state, setState] = useState([]);
  const { id } = useParams();
  const userId = id;
  const navigate = useNavigate();
  const pdfRef = useRef();

  const getUserDetail = async () => {
    try {
      const response = await axios.get(`${baseUrl}/user-details/${userId}`, {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage?.getItem("jwtToken")}`,
        },
      });
      setState(response.data.data.userDetail);
    } catch (error) {
      console.error(error);
    }
  };

  const pdfGenerate = async () => {
    if (!pdfRef.current) return;

    const element = pdfRef.current;

    if (element) {
      try {
        const pdf = new jsPDF({
          format: "a4",
          unit: "mm",
          margin: 5,
        }); // Create a single PDF instance
        const width = pdf.internal.pageSize.getWidth();
        const height = pdf.internal.pageSize.getHeight();
        let currentPageHeight = 0; // Track current page height

        const canvas = await html2canvas(element, { scale: 1 }); // Double the resolution
        const imgData = canvas.toDataURL("image/png");
        const contentWidth = canvas.width;
        const contentHeight = canvas.height;

        // Calculate scaling factor to fit content within margins
        const scaleX = Math.min(1, width / contentWidth);
        const scaleY = Math.min(1, (height + 5) / contentHeight); // Adjust for margins
        const scale = Math.min(scaleX, scaleY);

        // Center the content horizontally
        const xOffset = (width - contentWidth * scale) / 2;

        // Check if component height fits on current page
        if (currentPageHeight + contentHeight * scale <= height + 5) {
          pdf.addImage(
            imgData,
            "PNG",
            xOffset,
            currentPageHeight,
            contentWidth * scale,
            contentHeight * scale,
          );
          currentPageHeight += contentHeight * scale;
        } else {
          // Add page break and adjust for next page
          pdf.addPage();
          currentPageHeight = 0;
          pdf.addImage(
            imgData,
            "PNG",
            xOffset,
            currentPageHeight,
            contentWidth * scale,
            contentHeight * scale,
          );
          currentPageHeight += contentHeight * scale;
        }

        pdf.save(`${state?.user?.registration_no}.pdf`);
      } catch (error) {
        console.error("Error generating PDF:", error);
      }
    }
  };

  const handlePrescriptionPrint = (e) => {
    navigate(`/medical-verification/result/prescription"`, { state: userId });
    if (state?.user?.registration_no) {
      pdfGenerate();
    }
    // setTimeout(() => {
    //   window.print();
    // }, 1200);
  };

  const handlePrint = (e) => {
    navigate(`/medical-verification/result/report/${userId}`);
    if (state?.user?.registration_no) {
      pdfGenerate();
    }
    // setTimeout(() => {
    //   window.print();
    // }, 1200);
  };

  const collection = state?.user?.user_collections?.map(
    (collection) => collection.investigation_category?.investigation_group_id,
  );
  const uniqueCollection = [...new Set(collection)];

  useEffect(() => {
    userId && getUserDetail();
  }, [userId]);

  return (
    <>
      <section
        className="verification-certificate"
        ref={pdfRef}
        style={{
          width: "1500px",
          height: "100vh",
          fontFamily: "Verdana",
          fontWeight: "bolder",
        }}
      >
        <div className="container">
          <div className="row align-items-center mt-1">
            <img
              src="/certificate-header.jpg"
              alt="Report Header"
              className="mx-auto"
              style={{ width: "90%" }}
            />
          </div>
        </div>
        <hr />
        <div className="container">
          {(uniqueCollection?.length < 2 &&
            (state?.user?.is_pathology_done ||
              state?.user?.is_physical_done ||
              state?.user?.is_radiology_done)) ||
          (uniqueCollection?.length >= 2 &&
            uniqueCollection?.length < 3 &&
            (state?.user?.is_physical_done ? 1 : 0) +
              (state?.user?.is_pathology_done ? 1 : 0) +
              (state?.user?.is_radiology_done ? 1 : 0) >=
              2) ||
          (uniqueCollection?.length >= 3 &&
            state?.user?.is_pathology_done &&
            state?.user?.is_physical_done &&
            state?.user?.is_radiology_done) ? (
            <>
              <div className="row">
                {pathname.includes("/report") && (
                  <div className="col-12">
                    <h4
                      className="text-center fw-bold uppercase border border-dark fs-3 py-1"
                      style={{
                        color: `${
                          state?.user?.status === 1
                            ? "black"
                            : state?.user?.status === 2
                              ? "#5cb85c"
                              : state?.user?.status === 3
                                ? "red"
                                : state?.user?.status === 4 && "#0000FF"
                        }`,
                      }}
                    >
                      {state?.user?.status === 1 &&
                        `PROCESSING CERTIFICATE FOR ${state?.country?.name.toUpperCase()}`}
                      {state?.user?.status === 2 &&
                        `FIT CERTIFICATE FOR ${state?.country?.name.toUpperCase()}`}
                      {state?.user?.status === 3 &&
                        `UNFIT CERTIFICATE FOR ${state?.country?.name.toUpperCase()}`}
                      {state?.user?.status === 4 &&
                        `HELD UP CERTIFICATE FOR ${state?.country?.name.toUpperCase()}`}
                    </h4>
                  </div>
                )}
              </div>
              <div
                data-html2canvas-ignore
                className="print-btn-group d-flex align-items-center justify-content-center gap-2 mb-3"
              >
                <button className="btn btn-warning" onClick={handlePrint}>
                  Report
                </button>
                {state?.user?.status === 4 ? (
                  <button
                    className="btn btn-primary"
                    onClick={handlePrescriptionPrint}
                  >
                    Prescription
                  </button>
                ) : null}
              </div>
            </>
          ) : (
            <div className="row">
              <div
                className="col-12 d-flex align-items-center border border-dark"
                style={{ height: "10vh" }}
              >
                <h4
                  className="text-center fw-bold text-uppercase w-100 fs-5"
                  style={{
                    color: "red",
                    fontSize: "22px",
                  }}
                >
                  Your Report is Under Processing...
                </h4>
              </div>
            </div>
          )}
          {children}
        </div>
        {state?.user?.is_pathology_done &&
        state?.user?.is_radiology_done &&
        state?.user?.is_physical_done ? (
          <div
            style={{ background: "#9f7c28", fontSize: "13px" }}
            className="d-flex align-items-center justify-content-between p-3 mt-2 text-dark report-footer flex-column gap-3 flex-lg-row flex-md-row"
          >
            <div className="text-start">
              <div className="d-flex align-items-center justify-content-center gap-2">
                <i className="bi bi-geo-alt"></i>
                <div>
                  37/2 Zaman Tower, Purana Paltan
                  <br />
                  (Box Culvert Road), 1st Flr, Dhaka
                </div>
              </div>
            </div>
            <div className="text-start">
              <div className="d-flex align-items-center justify-content-center gap-2">
                <i className="bi bi-telephone-fill"></i>
                <div>
                  +88-02-9569676, +88-02-9568603
                  <br />
                  <div className="fw-bold text-start">
                    Hot Line: +88 01712 547 122
                  </div>
                </div>
              </div>
            </div>
            <div className="text-start">
              <i className="bi bi-envelope-fill"></i>
              <br />
              <i className="bi bi-globe"></i> www.edmcbd.com
            </div>
            <div className="d-flex align-items-center">
              <Link
                to={websiteUrlWithBase64ID}
                className="d-flex align-items-center"
              >
                <QRCode value={websiteUrlWithBase64ID} size={40} />
              </Link>
            </div>
          </div>
        ) : null}
      </section>
    </>
  );
};

export default VerificationById;
